import API from './api';

/**************************************************
 IMPORTANT : ne pas utiliser directement les API
 vous devez utiliser les services à la place
 **************************************************/

const exportedObject = {
  create (id_profile, id_product) {
    return API.post('/profiles/' + id_profile + '/products/' + id_product + '/stock-waitlist')
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
}

export default exportedObject;
